import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import events from '@/hooks/events';
import actions from '../constants';

const useApplyCatalogueObjects = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ template }) => handler({
    type: actions.APPLY_CATALOGUE_OBJECTS, category, code, template,
  }), [category, code]);
};

const useAddCatalogueLink = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ activeFieldName, template }) => handler({
    type: actions.ADD_CATALOGUE_LINK, category, code, activeFieldName, template,
  }), [category, code]);
};

const useShowCatalogueLinks = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ activeFieldName, activeIndex, template }) => handler({
    type: actions.SHOW_CATALOGUE_LINKS, category, code, activeFieldName, activeIndex, template,
  }), [category, code]);
};

const useUpdateActiveCatalogueObject = () => {
  const handler = useDispatch();
  return useCallback(({ index }) => handler({ type: actions.UPDATE_ACTIVE_CATALOGUE_OBJECT, index }), []);
};

const useWithTemplate = (type) => {
  const handler = useDispatch();
  return useCallback(({ template }) => handler({ type, template }), []);
};

const useInsertCatalogueLink = () => useWithTemplate(actions.INSERT_CATALOGUE_LINK);
const useInsertCatalogueObject = () => useWithTemplate(actions.INSERT_CATALOGUE_OBJECT);
const useEditCatalogueObjects = () => useWithTemplate(actions.EDIT_CATALOGUE_OBJECTS);

const useUpdateCatalogueObjectProperties = () => {
  const handler = useDispatch();
  return useCallback(({ properties, fields, template }) => handler({
    type: actions.UPDATE_CATALOGUE_OBJECT_PROPERTIES, properties, fields, template,
  }), []);
};

const useUpdateCatalogueObjectsProperties = () => {
  const handler = useDispatch();
  return useCallback(({ properties }) => handler({
    type: actions.UPDATE_CATALOGUE_OBJECTS_PROPERTIES, properties,
  }), []);
};

const useAddCatalogueObject = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ activeFieldName, template }) => handler({
    type: actions.ADD_CATALOGUE_OBJECT, category, code, activeFieldName, template,
  }), [category, code]);
};

const useDeleteCatalogueObject = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ activeFieldName, activeIndex, template }) => handler({
    type: actions.DELETE_CATALOGUE_OBJECT, category, code, activeFieldName, activeIndex, template,
  }), [category, code]);
};

const useShowCatalogueObjects = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ activeFieldName, activeIndex, template }) => handler({
    type: actions.SHOW_CATALOGUE_OBJECTS, category, code, activeFieldName, activeIndex, template,
  }), [category, code]);
};

const useUpdateDatasetCatalogueObjectProperties = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({
    activeFieldName, activeIndex, properties, template,
  }) => handler({
    type: actions.UPDATE_DATASET_CATALOGUE_OBJECT_PROPERTIES,
    category,
    code,
    activeFieldName,
    activeIndex,
    properties,
    template,
  }), [category, code]);
};

export default {
  useAddCatalogueLink,
  useAddCatalogueObject,
  useApplyCatalogueObjects,
  useDeleteActiveCatalogueObject: () => events.useSimpleDispatch(actions.DELETE_ACTIVE_CATALOGUE_OBJECT),
  useDeleteCatalogueObject,
  useEditCatalogueObjects,
  useHideCatalogueObjects: () => events.useSimpleDispatch(actions.HIDE_CATALOGUE_OBJECTS),
  useInsertCatalogueLink,
  useInsertCatalogueObject,
  useShowCatalogueLinks,
  useShowCatalogueObjects,
  useUpdateActiveCatalogueObject,
  useUpdateCatalogueObjectProperties,
  useUpdateCatalogueObjectsProperties,
  useUpdateDatasetCatalogueObjectProperties,
};
